import { useMemo } from 'react'
import classNames from 'classnames'
import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { certificationPath, certificationItems } from '../../../utility/coachCertification'
import { useCoachCertification } from './useCoachCertification'
import CertificationNotice from './CertificationNotice'
import CertificationLoader from './CertificationLoader'
import ProgressBar from './ProgressBar'
import SectionRow from './SectionRow'

import classes from './SectionsPage.module.scss'

const SectionsPage = () => {
  const { t } = useTranslation()
  const { certificationId } = useParams()
  const { certification, notFound, failed } = useCoachCertification(certificationId)
  const items = useMemo(() => (certification ? certificationItems(certification) : []), [certification])

  if (notFound || failed) { return <CertificationNotice notFound={notFound} /> }
  if (!certification) { return <CertificationLoader /> }

  return (
    <main className={classes.page}>
      <header className={classes.header}>
        <div className={classNames('position-relative', classes.headerInner)}>
          <Link to={certificationPath(certificationId)} className={classes.back}>
            <i className='fa fa-arrow-left' aria-hidden='true' />
            {t('portal.certification.sections.back')}
          </Link>
          <h1 className={classes.title}>{certification.name}</h1>
          <ProgressBar
            done={certification.completedCount}
            total={certification.totalCount}
            label={t('portal.certification.priceCard.progress', { done: certification.completedCount, total: certification.totalCount })}
            thick
            onDark
            className={classes.progress}
          />
        </div>
      </header>

      <div className={classes.body}>
        <div className='d-flex align-items-baseline justify-content-between flex-wrap mb-3'>
          <span className={classes.label}>{t('portal.certification.sections.sectionsTitle')}</span>
          <span className={classes.note}>
            {t(certification.sequential ? 'portal.certification.sections.sequentialNote' : 'portal.certification.sections.anyOrderNote')}
          </span>
        </div>
        <div className='d-flex flex-column'>
          {certification.sections.map((section, index) => (
            <SectionRow key={section.id} section={section} number={index + 1} items={items} />
          ))}
          {certification.finalQuiz && <SectionRow finalQuiz={certification.finalQuiz} number={certification.sections.length + 1} items={items} />}
        </div>
      </div>
    </main>
  )
}

export default SectionsPage
